<template>
  <div style="margin-bottom:1.5rem">
    <div class="box">
      <admin-box-item title="가격 정보">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item label="판매 가격 사용여부">
              <lp-radio :val.sync="prod_price.price_type"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'사용',value:0}, {label:'미사용', value:1}]"></lp-radio>
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="prod_price.price_type === 0">
            <admin-form-item label="가격설정" desc=""
              :customHeaderStyle="{
                'display': 'block'
              }">
              <template #desc2>
                <div class="size-13 weight-400" style="color: #4a4a4a; margin-bottom: 8px">요일별로 일정을 등록할 수 있습니다.<br/>
                  일정이 중복되는 경우, <span class="primary">상위에 노출되는 일정이 우선 적용</span>됩니다.</div>
              </template>
              <template v-if="prod.id">
                <button v-if="schedules.length===0"
                  class="button is-primary" @click="clickAdd">가격 설정하기</button>
                <template v-else>
                <div class="box-schedule" v-for="(item,idx) in schedules" :key="`sch-${idx}`">
                  <div class="title-schedule flex-between">
                    <div class="flex-align" style="gap:0 4px">
                      <img :src="svgSrc('u_calendar')" alt="calendar">
                      <div>{{ item.start_date }} ~ {{ item.end_date }}</div>
                    </div>
                    <div class="flex-align" style="gap:0 16px">
                      <div class="txt-primary unselect" @click="clickModify(idx)">수정</div>
                      <i class="material-icons btn-close txt-sub3" @click="clickDel(idx)">close</i>
                    </div>
                  </div>
                  <div v-if="item.all_date">
                    <div class="item-schedule" v-for="(sch, sidx) in item.schedule.slice(0,1)" :key="'all-date-'+sidx">
                      <div class="txt-sub3 size-13">모든요일</div>
                      <div class="flex-center">
                        <div :class="`${ sch.possible_resv ? 'tag-enable' : 'tag-disable'}`">{{ sch.possible_resv ? '영업' : '휴무' }}</div>
                      </div>
                      <div class="txt-primary" style="height:16px">
                        <span v-if="sch.possible_resv && sch.is_discount">{{ sch.discount_type === 0 ? sch.discount_rate + '%' : currency(sch.discount_price) }}</span>
                      </div>
                      <div style="height:16px"><span v-if="sch.possible_resv">{{ sch.sale_price !== 0 ? currency(sch.sale_price) : currency(sch.price) }}</span></div>
                    </div>
                  </div>
                  <div class="grid-schedule" v-else>
                    <div v-for="(sch,sidx) in item.schedule" :key="`s-child-${sidx}`"
                      class="item-schedule">
                      <div class="txt-sub3 size-13">{{ days[sidx] }}</div>
                      <div class="flex-center">
                        <div :class="`${ sch.possible_resv ? 'tag-enable' : 'tag-disable'}`">{{ sch.possible_resv ? '영업' : '휴무' }}</div>
                      </div>
                      <div class="txt-primary" style="height:16px">
                        <span v-if="sch.possible_resv && sch.is_discount && (sch.discount_type !== 0 || sch.discount_price !== 0)">{{ sch.discount_type === 0 ? sch.discount_rate + '%' : currency(sch.discount_price) }}</span>
                      </div>
                      <div style="height:16px"><span v-if="sch.possible_resv">{{ sch.sale_price !== 0 ? currency(sch.sale_price) : currency(sch.price) }}</span></div>
                    </div>
                  </div>

                </div>
                <div class="txt-primary flex-align unselect" style="margin:8px 0" @click="clickAdd">
                  <i class="material-icons">add</i> 추가하기
                </div>
              </template>
              </template>
              <block-negative v-else
                              :center="true"
                              notTxt="상품 시간 설정을 위해서 먼저 저장해주세요."
                              button="저장하기"
                              @clicked="$emit('save')"></block-negative>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="원화 표시">
              <lp-radio :val.sync="prod_price.won_type"
                        value_name="value"
                        label_name="label"
                        :data="[{label:'원',value:0},{label:'원~',value:1}]"></lp-radio>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <div class="divider"></div>
          </div>
          <div class="column is-full">
            <admin-form-item label="판매 기간" desc="판매 기간을 설정하지 않을 경우, 무한대로 설정됩니다.">
              <div class="flex" style="flex-wrap:wrap">
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="prod_price.start_date"
                    @setDate="date => selDateMin(date, 'price')"></admin-date-picker>
                </div>
                <div class="lp-dating">&#126;</div>
                <div style="align-items: center;">
                  <admin-date-picker
                    type="datetime"
                    :data="prod_price.end_date"
                    @setDate="date => selDateMax(date, 'price')"></admin-date-picker>
                </div>
              </div>
            </admin-form-item>
            <div v-if="errorTime" style="font-size: 0.8rem;color: #db2828;">시작 시간/종료 시간 범위 설정이 잘못되었습니다.</div>
          </div>
        </div>
      </admin-box-item>
    </div>
    <modal-price-schedule ref="scheduleModal" :modifyItem="modifyItem"
                          :prod="prod"
                          @updatePrice="res => $emit('updatePrice', res)"
                          @onModify="onModify"
                          @onAdd="onAdd"></modal-price-schedule>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";
  import moment from 'moment';
  import ProductPanelMixin from "../../../../mixins/ProductPanelMixin";
  import ModalPriceSchedule from "./ModalPriceSchedule";
  import BlockNegative from "./BlockNegative";

  export default {
    name: "PanelBookingPrice",
    components: {BlockNegative, ModalPriceSchedule, LpRadio},
    mixins: [
      ProductPanelMixin
    ],
    props: {
      prod: {
        type: Object
      },
      prod_price: {
        type: Object
      },
      panel: {
        type: Object
      },
      disabled: {
        type: Boolean
      }
    },
    created() {
      this.getData();
    },

    data() {
      return {
        days: ['월','화','수','목','금','토','일'],
        schedules: [],
        modifyItem: undefined,
        modifyIndex: 0
      }
    },
    computed: {
      errorTime() {
        let start_date = this.prod_price.start_date;
        let end_date = this.prod_price.end_date;
        if (start_date && end_date) {
          let is_before = moment(start_date).isBefore(end_date);
          return !is_before;
        }
      },
      errorDiscountTime () {
        let start_date = this.prod_price.discount_start;
        let end_date = this.prod_price.discount_end;
        if (start_date && end_date) {
          let is_before = moment(start_date).isBefore(end_date);
          return !is_before;
        }
      }
    },
    methods: {
      getData() {
        this.$axios.get(this.getUrl(`booking/product/${this.prod.id}/schedule_price`)).then(res=> {
          this.schedules = res.data;
        });
      },
      clickAdd() {
        this.modifyItem = undefined;
        setTimeout(()=> {
          this.$refs.scheduleModal.open();
        }, 100);
      },
      clickModify(idx) {
        this.modifyIndex = idx;
        this.modifyItem = this.cloneItem(this.schedules[idx]);
        setTimeout(()=> {
          this.$refs.scheduleModal.open();
        },100);
      },
      clickDel(idx) {
        let item = this.schedules[idx];
        if(item.id) {
          this.$axios.delete(this.getUrl(`booking/product/${this.prod.id}/schedule_price/${this.schedules[idx].id}`), item).then(res => {
            removeIndex(this.schedules, idx);
            this.$emit('updatePrice', res.data.price);
            this.$emit('onUpdate');
            this.toastStatus('해당 기간 일정/가격이 삭제되었습니다.');
          });
        } else {
          removeIndex(this.schedules, idx);
        }
      },
      onAdd(item) {
        this.schedules.splice(0,0,item);
        this.$emit('onUpdate');
      },
      onModify(item) {
        this.schedules[this.modifyIndex] = item;
        this.$forceUpdate();
        this.$emit('onUpdate');
      },
      selDateMin(date, type) {
        if (type === 'price') this.prod_price.start_date = date;
        else if (type === 'discount') this.prod_price.discount_start = date;
        else if (type === 'all_time') this.prod_price.all_time_start = date;
      },
      selDateMax(date, type) {
        if (type === 'price') this.prod_price.end_date = date;
        else if (type === 'discount') this.prod_price.discount_end = date;
        else if (type === 'all_time') this.prod_price.all_time_end = date;
      },
    }
  }

</script>

<style lang="stylus" scoped>
  .box
    box-shadow unset
  .divider
    width 100%
    height 1px
    background-color #eeeeee
    margin 4px 0

  .box-schedule
    border 1px solid #dddddd
    margin-bottom 16px
  .box-schedule:last-child
    margin-bottom 0

  .title-schedule
    border-bottom 1px solid #eeeeee
    padding 16px
  .btn-close
    font-size 15px
    width 16px
    height 16px
    cursor pointer

  .grid-schedule
    display grid
    grid-template-columns repeat(7, 1fr)
  .item-schedule
    border-right 1px solid #eeeeee
    text-align center
    padding 8px 0
    font-size 12px
    display grid
    row-gap 2px
  .item-schedule:last-child
    border-right 0

  .tag-enable
  .tag-disable
    color white
    padding 2px 4px


  .tag-enable
    background-color #363636
  .tag-disable
    background-color #989898

</style>
